import { useQuery } from 'react-query';
import { getLoggedInUsername } from 'api/account';
import { getUserBillingCompanies, BillingCompany } from 'api/organisations';
import { cookies } from 'static';

const hasAuthToken = () => Boolean(localStorage.getItem(cookies.FarmersPlanToken));

export const billingCompaniesQueryKey = (farmId?: string | number | null) =>
  ['lsp-billing-companies', getLoggedInUsername() ?? '', farmId != null ? String(farmId) : ''] as const;

export const useBillingCompanies = (farmId?: string | number | null) =>
  useQuery<BillingCompany[]>(
    billingCompaniesQueryKey(farmId),
    () => getUserBillingCompanies(farmId),
    {
      enabled: hasAuthToken(),
      staleTime: 60 * 1000,
      retry: 1,
    },
  );
